import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { type MainProps } from '../types/ScreenTypes';

const Main: React.FC<MainProps> = ({ navigation, route }) => {
    return (
        <View style={styles.container}>
            <Text>Main page</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#f5f5f5',
        flex: 1,
    },
});

export default Main;
